export default __webpack_public_path__ + "static/media/Logo Turismo-02.91290372.WebP";